import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useMergedClsPrefix as m } from "../../_mixins/use-config.js";
import f, { ellipsisProps as a, createLineClampClass as d, createCursorClass as u } from "./Ellipsis.js";
import c from "./styles/index.cssr.js";
import g from "../../_mixins/use-style.js";
import { defineComponent as C, h as s, mergeProps as o } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as h } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const k = C({
  name: "PerformantEllipsis",
  props: a,
  inheritAttrs: !1,
  setup(i, {
    attrs: p,
    slots: t
  }) {
    const n = h(!1), l = m();
    return g("-ellipsis", c, l), {
      mouseEntered: n,
      renderTrigger: () => {
        const {
          lineClamp: e
        } = i, r = l.value;
        return s("span", Object.assign({}, o(p, {
          class: [`${r}-ellipsis`, e !== void 0 ? d(r) : void 0, i.expandTrigger === "click" ? u(r, "pointer") : void 0],
          style: e === void 0 ? {
            textOverflow: "ellipsis"
          } : {
            "-webkit-line-clamp": e
          }
        }), {
          onMouseenter: () => {
            n.value = !0;
          }
        }), e ? t : s("span", null, t));
      }
    };
  },
  render() {
    return this.mouseEntered ? s(f, o({}, this.$attrs, this.$props), this.$slots) : this.renderTrigger();
  }
});
export {
  k as NPerformantEllipsis
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/ellipsis/src/PerformantEllipsis.js
// module id = 1687
// module chunks = 67